<template>
    <div >
        <h3>{{ getTranslation('licence-configurator', 'licence_configurator_page_title') }}</h3>

        <div
            v-for="product in filteredProducts"
            :key="product.id"
            class="row show-grid product mt-4"
            :class="'group-' + product.name.replace(/\s+/g, '-').toLowerCase()"
        >
            <div class="licenses__wrapper col-12">
                <h3 class="licenses__title"><span class="details-panel__body--headerimg">
                    <img v-bind:src="'images/program-icons/' + product.title.replace(' ', '-') + '.svg'" alt="icon">
                </span>
                    {{ getTranslation('licence-configurator', 'product_name_subscription', {'name': product.name }) }}
                </h3>
            </div>

            <template>
                <setup-new v-bind:product="product"></setup-new>
            </template>


            <!-- upgrade to perpetual-->
            <template v-if="hasNewPrograms(product.id) || hasLeasesForPerpetualUpgrade(product.id)">
                <setup-upgrade v-bind:product="product"></setup-upgrade>
            </template>


            <template v-if="hasNewProgramsCustom(product.id) || hasSubscriptionCustomization(product.id) || hasExistingPerpetualUpgrade(product.id)">
                <div class="mt-4 mb-4 col-12">
                    <setup-summary-licences v-bind:product="product" v-bind:licenceType="getQtyName('lease', 'cloud')" translate="cloud_time_licences_product"></setup-summary-licences>
                </div>
            </template>

        </div>

        <template v-if="noCustomizationMessage()">
            <div class="mt-4 mb-4">
                {{ getTranslation('licence-configurator', 'no_customization_available') }}
            </div>

        </template>

        <div class="form-group mt-4">
            <label for="order_note">{{ getTranslation('front', 'NOTE') }}</label>
            <textarea id="order_note" class="form-control" v-model="userNote" rows="5" cols="40"></textarea>
        </div>

        <div class="order-summary__footer mt-4">
            <a v-bind:href="navigation.home"  class="btn btn-back">
                <svg width="15" height="13" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path fill="currentColor" d="M231.536 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273H436c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H60.113L238.607 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"></path>
                </svg>
                {{ getTranslation('front', 'back') }}
            </a>

            <a @click="goToUserInfo()" id="continueNextStep"  class="btn btn-primary submitbtn btn-order ml-auto submitLicenceSetup">
                <span class="continue">{{ getTranslation('front', 'continue') }}</span>
                <span class="continue-spinner align-items-center d-none">
                    <b-spinner small variant="light" label="Loading..."></b-spinner> {{ getTranslation('front', 'loading')}}
                </span>
            </a>
        </div>



        <b-modal id="bv-modal-warning" centered hide-footer>
            <template #modal-title>
                <div class="modal-title__icon">
                    <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" ><path fill="currentColor" d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z"></path>
                    </svg>
                </div>
                <span>{{ getTranslation('key-setup-vue', 'warning') }}</span>
            </template>
            <div class="d-block text-center">
                <p>{{ getTranslation('home','empty_cart_error') }}</p>
                <br><br>
            </div>
            <div class="text-center">
                <b-button class="mt-3 mx-auto"  @click="closeModal()">{{ getTranslation('front', 'close') }}</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>


export default {

        methods: {
            noCustomizationMessage() {
                let self = this;
                let showMessage = true;
                _.forOwn(this.products, function(p) {
                    if (!self.isTruss4Product(p.id)) {
                        if (self.hasExistingLeases(p.id)) {
                            showMessage = false;
                            showMessage = false;
                        }
                        if (self.hasNewPrograms(p.id)) {
                            showMessage = false;
                        }
                    }
                });
                return showMessage;
            },
            hasSubscriptionPromo() {
                if (_.isNil(this.$store.state.cart.subscriptionPromo)) {
                    return false;
                }
                if (_.isEmpty(this.$store.state.cart.subscriptionPromo)) {
                    return false;
                }
                return true;
            },
            canContinueNextStep() {
                if (this.$store.state.cart.programs.length) {
                    return true;
                }
                if (this.hasSubscriptionPromo()) {
                    return true;
                }

                let self = this;
                let hasAnyPurchase = false;
                _.forOwn(this.products, function(p) {
                    if (self.leaseProlongPrice[p.id]) {
                        hasAnyPurchase = true;
                    }
                    if (self.hasSubscriptionCustomization(p.id)) {
                        hasAnyPurchase = true;
                    }
                    if (self.hasExistingPerpetualUpgrade(p.id)) {
                        hasAnyPurchase = true;
                    }
                });
                if (hasAnyPurchase) {
                    return true;
                }
                return false;
            },

            closeModal() {
                this.$bvModal.hide('bv-modal-warning')
            },
            hasNewProgramsCustom(id) {
                if (this.isTruss4Product(id)) {
                    return false;
                }
                if (_.isEmpty(this.$store.state.cart.programs)) {
                    return false;
                }
                let index = _.findIndex(this.$store.state.cart.programs, function(p) { return (p.product === id); });
                return index >= 0;
            },
            hasSubscriptionCustomization(id) {
                let filtered = _.filter(this.$store.state.cart.leaseProlongConfigs, function(l) { return (l.product === id); });
                return !_.isEmpty(filtered);
            },
            hasExistingPerpetualUpgrade(id) {
                let filtered = _.filter(this.$store.state.cart.perpetualUpgrade, function(l) { return (l.product === id); });
                return !_.isEmpty(filtered);
            },
            goToUserInfo() {
                let self = this;
                this.setSpinner();
                this.canSubmit = false;

                if (this.canContinueNextStep() === false) {
                    this.$bvModal.show('bv-modal-warning');
                    this.canSubmit = true;
                    this.resetSpinner();
                    return;
                }

                //reset days if the custom date is one year
                _.forOwn(this.products, function(p) {
                    if (!_.isNil(self.$store.state.cart.leaseOptions[p.id])) {
                        let leaseOptions =  self.$store.state.cart.leaseOptions[p.id];
                        if (leaseOptions.customDate === leaseOptions.minDate && leaseOptions.showDatePicker === true && leaseOptions.selectedOption === 3) {
                            _.forEach(self.$store.state.cart.programs, function(pr) {
                                if (pr.product === p.id) {
                                    let payload = {
                                        id: pr.id,
                                        upgrade: false,
                                        column: 'days'
                                    }
                                    self.$store.commit('upgradeCartProgram', payload);
                                }
                            });
                        }
                    }
                });

                if (this.$store.state.cart.cartStep <= 3) {
                    let payload = {'step': 3};
                    this.$store.commit('setCartStep', payload);
                }

                let payload = {'text': this.userNote};
                this.$store.commit('setUserNote', payload);
                window.location.href = this.navigation.user_info;
            },
            hasLeaseProlong(id) {
                if (this.isTruss4Product(id)) {
                    return false;
                }
                if (_.isUndefined(this.$store.state.cart.leaseProlong[id])) {
                    return false;
                }
                if (_.isEmpty(this.$store.state.cart.leaseProlong[id])) {
                    return false;
                }
                if (
                    this.$store.state.cart.leaseProlong[id].status === false ||
                    this.$store.state.cart.leaseProlong[id].status === 0
                ) {
                    return false;
                }
                let hasLease = false;
                _.forOwn(this.$store.state.cart.leaseProlong[id].info, function (pr) {
                    if (pr.selected) {
                        hasLease = true;
                    }
                });

                return hasLease;
            },
            hasPriceChange(id) {
                return true;
            },
            hasNewPrograms(id) {
                if (this.isTruss4Product(id)) {
                    return false;
                }
                if (_.isEmpty(this.$store.state.cart.programs)) {
                    return false;
                }
                let index = _.findIndex(this.$store.state.cart.programs, function(p) { return p.product == id; });
                return index >= 0;
            },
            hasLeasesForPerpetualUpgrade(id) {
                if (this.isTruss4Product(id)) {
                    return false;
                }
                let filtered = _.filter(this.licences, function(l) { return (l.permanent_license == 0 && l.product == id); });
                console.log(filtered);
                return !_.isEmpty(filtered);
            },
            showReferenceDate(id) {
                return !_.isNil(this.referenceDates[id]);
            },
            hasExistingLeases(id) {
                let index = _.findIndex(this.leaseData, function(l) { return l.product == id; });
                return index >= 0;
            },
            showProduct(id) {
                if (this.isTruss4Product(id)) {
                    return false;
                }
                if (this.hasNewPrograms(id)) {
                    return true;
                }
                if (this.hasLeaseProlong(id)) {
                    return true;
                }
                if (this.hasExistingLeases(id)) {
                    return true;
                }
                return false;
            },
        },
        mounted() {
            window.licenceSetup=this;
        },
        computed: {
            filteredProducts() {
                return Object.values(this.products).filter(p => this.showProduct(p.id));
            },
            leaseProlongPrice() {
                let self = this;
                let total = {};
                let keys = Object.keys(this.products);

                for (const key of keys) {
                    if (_.isUndefined( total[key])) {
                        total[key] = 0;
                    }
                    if (!_.isUndefined(this.$store.state.cart.leaseProlong[key])) {
                        if (!_.isNil(this.$store.state.cart.leaseProlong[key])) {
                            if (this.$store.state.cart.leaseProlong[key].status) {
                                if (this.isTruss4Product(key)) {
                                    let info = this.$store.state.cart.leaseProlong[key].info[0];
                                    total[key] = this.getTruss4Price(info.id, '', info.licence_type, info.product, this.$store.state.cart.leaseProlong[key].info.length, true)
                                } else {
                                    _.forOwn(this.$store.state.cart.leaseProlong[key].info, function (pr, ind) {
                                        if (pr.selected) {
                                            let basePrice = self.getProgramPrice(pr.id, '', 'cloud_time_quantity', pr.product, pr.quantity);
                                            total[key] = total[key] + basePrice;
                                        }
                                    });
                                }
                            }
                        }

                    }
                }
                return total;
            },
        },
        data() {
            return {
                navigation: window.quickNavigationUrls,
                products: window.jsonProducts,
                leaseOptions: {},
                customDates: {},
                leaseData: JSON.parse(window.leaseData),
                referenceDates: JSON.parse(window.referenceDates),
                mergeLeases: false,
                customDate: {1 : '', 2: ''},
                selectedOption: {1 : '', 2: ''},
                userNote: '',
                licences: JSON.parse(window.licences),
            };
        }
    }
</script>

